var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BlockBar',{attrs:{"items":_vm.months,"custom-class":"background"}})}
var staticRenderFns = []

export { render, staticRenderFns }